export default __webpack_public_path__ + "static/media/Leaf.c58023a6.svg";